module.exports = __webpack_public_path__ + "img/prodigal.c3cda72a.jpg";